<template>
  <div>
    <div class="table-responsive">
      <table class="table p-0 m-0 dataTable no-footer min-h-[150px] text-nowrap">
        <thead class="bg-white">
          <tr class="py-[5px]">
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Name
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Status
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Role
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Branch
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Type
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Staff ID
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Actions
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-if="loading">
            <td colspan="12" class="text-center">
              <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px">
                  Please wait while we loading the User's Lists
                </h3>
              </div>
            </td>
          </tr>
          <tr v-for="u in users" :key="u.id" v-else>
            <td>
              <b>
                <span class="text-[14px] font-medium leading-[16.94px] text-[#353535]" v-if="u.displayName">
                  {{ u.displayName }}
                  <br />
                </span>
              </b>
              <span class="text-[14px] font-medium leading-[16.94px] text-[#96a0b5]">{{ u.emailAddress ? u.emailAddress
                : u.phoneNumber }}</span>
              <br />
              <span class="text-[14px] font-medium leading-[16.94px] text-[#96a0b5]">{{ u.name }}</span>
            </td>
            <td>
              <span class="flex items-center gap-[4px] max-w-max w-full" :class="[
                'badge',
                {
                  'badge-success': u.status === 'Active',
                  'badge-danger': u.status === 'Inactive',
                  'badge-primary': u.status === 'Pending',
                },
              ]">
                <span class="w-[10px] h-[10px] rounded-[1px]" :style="{
                  backgroundColor:
                    u.status === 'Active'
                      ? '#16a249'
                      : u.status === 'Inactive'
                        ? '#EF5253'
                        : '#7367F0',
                }"></span>

                <span class="text-[12px] font-normal leading-[16.94px]">
                  {{ u.status == "Pending" ? "Invitation sent" : u.status }}
                </span>
              </span>
            </td>
            <td class="text-[14px] font-normal leading-[16.94px]">
              {{ u.role }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px]">
              {{ u.branch ? u.branch.name : "N/A" }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px]">
              {{
                u.userType === "Office"
                  ? "Business"
                  : u.userType === "SalesForce"
                    ? "Sales"
                    : u.type
              }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px]">
              {{ u.staffId }}
            </td>
            <td @click="toggleDropdown(u.id)">
              <div class="dropdown">
                <button class="btn-no-border" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <span
                    class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none">
                    ...
                  </span>
                </button>
                <ul class="dropdown-menu shadow-none" aria-labelledby="dropdownMenuButton">
                  <li
                    class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
                    @click="viewUser(u)">
                    View
                  </li>
                  <!-- <li
                    class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
                    v-if="
                      u.status != 'Inactive' &&
                        hasPermission('User_Update' || 'Sales_Team_Update')
                    "
                    @click="viewEditUser(u)"
                  >
                    Edit User
                  </li> -->
                  <li
                    class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
                    v-if="
                      u.status === 'Active' &&
                      hasPermission('User_Update' || 'Sales_Team_Update')
                    " @click="resetPassword(u)">
                    Reset Password
                  </li>
                  <li
                    class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
                    @click.prevent="viewResend(u)" v-if="
                      u.id != user.id &&
                      u.status == 'Pending' &&
                      hasPermission(
                        'User_Send_Invite' || 'Sales_Team_Send_Invite'
                      )
                    ">
                    Resend Invite
                  </li>
                  <li @click="OpenDisable(u)" v-if="
                    (u.id != user.id &&
                      hasPermission('User_Enable_Disable')) ||
                    hasPermission('Sales_Team_Enable_Disable')
                  " class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[12px] px-[16px]">
                    {{
                      u.status === "Active"
                        ? "Disable"
                        : u.status === "Pending"
                          ? "Disable"
                          : "Enable"
                    }}
                  </li>
                  <!-- <li
                    class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[12px] px-[16px]"
                    @click.prevent="confirmDelete(u.id)"
                    v-if="
                      u.status === 'Pending' &&
                        u.userType === 'Office' &&
                        hasPermission('User_Delete')
                    "
                  >
                    Delete
                  </li> -->
                </ul>
              </div>
            </td>
          </tr>
          <tr v-if="!users.length && !loading">
            <td colspan="12">
              <div class="text-center" style="padding-top: 50px">
                <span style="font-size: 4.615rem" class="fa-solid fa-user text-[#2463EB]"></span>
              </div>
              <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]" style="padding-bottom: 100px">
                Users not found
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination :limit="pageSize" :count="pageCount" :page="pageNumber" :itemsCount="count" @changePage="changePage"
        @changeLimit="changeLimit" />
    </div>

    <!-- view user popup -->
    <div v-if="isModalVisible" class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
      id="popup-content" @click.self="closeModal">
      <div class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[16px] md:text-[20px] leading-[20px] font-semibold capitalize">
            Viewing
            {{ getRoleName(selecteduser.role).type }}

            User:
            {{
              getRoleName(selecteduser.role).type === "sales"
                ? selecteduser.lastName && selecteduser.otherNames
                  ? `${selecteduser.lastName} ${selecteduser.otherNames}`
                  : selecteduser.displayName
                : selecteduser.displayName ||
                `${selecteduser.lastName} ${selecteduser.otherNames}`
            }}
          </p>
          <button class="text-2xl text-[#353535] outline-none focus:outline-none" type="button" @click="closeModal">
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="bg-white p-1 rounded-[4px] flex items-center gap-[16px] mt-[16px]">
          <button :class="[
            'text-[14px] font-normal py-[6px] px-[16px] sm:px-[24px] rounded-[8px] w-full max-w-max',
            {
              'bg-[#2463EB] text-white': activeTab === 'profile',
              'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'profile',
            },
          ]" @click="switchTab('profile')">
            User Profile
          </button>
          <button :class="[
            'text-[14px] font-normal py-[6px] px-[16px] sm:px-[24px] rounded-[8px] w-full max-w-max',
            {
              'bg-[#2463EB] text-white': activeTab === 'distributor',
              'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'distributor',
            },
          ]" @click="switchTab('distributor')" v-if="
            selecteduser.status != 'Inactive' &&
            selecteduser.status != 'Pending' &&
            selecteduser.role.isDistributorManager &&
            hasPermission('Sales_Team_Update') &&
            getRoleName(selecteduser.role).type === 'sales'
          ">
            Assigned Distributor
          </button>
          <!-- <button
            v-if="
              getRoleName(selecteduser.role).type === 'sales' &&
                 selecteduser.status != 'Inactive' &&
                selecteduser.status != 'Pending' &&
                selecteduser.role.isGroupManager &&
                hasPermission('Sales_Team_Update')
            "
            :class="[
              'text-[14px] font-normal py-[6px] px-[16px] sm:px-[24px] rounded-[8px] w-full max-w-max',
              {
                'bg-[#2463EB] text-white': activeTab === 'groups',
                'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'groups',
              },
            ]"
            @click="switchTab('groups')"
          >
            Assigned Groups
          </button>
          <button
            v-if="
              selecteduser.status != 'Inactive' &&
                selecteduser.status != 'Pending' &&
                selecteduser.role.isStateManager &&
                hasPermission('Sales_Team_Update') &&
                getRoleName(selecteduser.role).type === 'sales'
            "
            :class="[
              'text-[14px] font-normal py-[6px] px-[16px] sm:px-[24px] rounded-[8px] w-full max-w-max',
              {
                'bg-[#2463EB] text-white': activeTab === 'state',
                'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'state',
              },
            ]"
            @click="switchTab('state')"
          >
            Assigned State
          </button> -->
          <button v-if="
            selecteduser.status != 'Inactive' &&
            selecteduser.status != 'Pending' &&
            (selecteduser.role.canManageDistributorManagers ||
              selecteduser.role.canManageGroupManagers ||
              selecteduser.role.canManageStateManagers) &&
            hasPermission('Sales_Team_Update') &&
            getRoleName(selecteduser.role).type === 'sales'
          " :class="[
            'text-[14px] font-normal py-[6px] px-[16px] sm:px-[24px] rounded-[8px] w-full max-w-max',
            {
              'bg-[#2463EB] text-white': activeTab === 'team',
              'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'team',
            },
          ]" @click="switchTab('team')">
            Assigned Teams
          </button>
        </div>
        <div v-if="activeTab === 'profile'">
          <div class="bg-white px-[24px] py-[32px] mt-[16px] rounded-[4px]">
            <div class="flex justify-between items-center">
              <div class="flex flex-col md:flex-row justify-between items-start gap-[5px] md:items-center">
                <h2 class="font-semibold text-[20px] leading-[20px] text-[#353535] max-w-[170px] w-full">
                  User Information
                </h2>
                <span class="flex items-center gap-[4px] max-w-max w-full" :class="[
                  'badge',
                  {
                    'badge-success': selecteduser.status === 'Active',
                    'badge-danger': selecteduser.status === 'Inactive',
                    'badge-primary': selecteduser.status === 'Pending',
                  },
                ]">
                  <span class="text-[12px] font-normal leading-[16.94px]">
                    {{ selecteduser.status }}
                  </span>
                </span>
              </div>
              <!-- <button
                class="text-[#96a0b5] text-[14px] font-normal py-[12px] px-[24px] rounded-[8px] border-[#96A0B5] border-solid border outline-none font-semibold"
                @click="editingUsers"
              >
                <span class="mdi mdi-pencil text-2xl mr-[5px]"></span>
                Edit
              </button> -->
            </div>
            <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
              <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                Name
              </h2>
              <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">
                {{
                  getRoleName(selecteduser.role).type === "sales"
                    ? selecteduser.lastName && selecteduser.otherNames
                      ? `${selecteduser.lastName} ${selecteduser.otherNames}`
                      : selecteduser.displayName
                    : selecteduser.displayName ||
                    `${selecteduser.lastName} ${selecteduser.otherNames}`
                }}
              </span>
            </div>

            <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
              <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                Role
              </h2>

              <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{
                getRoleName(selecteduser.role).role }}</span>
            </div>
            <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
              <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                User Name
              </h2>
              <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ selecteduser.username }}</span>
            </div>
            <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
              <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                Email
              </h2>
              <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ selecteduser.emailAddress
              }}</span>
            </div>
            <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
              <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                Phone Number
              </h2>
              <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ selecteduser.phoneNumber
              }}</span>
            </div>
            <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
              <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                Branch
              </h2>
              <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ selecteduser.branch ?
                selecteduser.branch.name : "N/A" }}
              </span>
            </div>
            <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
              <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                Staff ID
              </h2>
              <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ selecteduser.staffId ?
                selecteduser.staffId : "N/A" }}
              </span>
            </div>
            <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
              <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                Created
              </h2>
              <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ formatDate(selecteduser.created)
              }}
              </span>
            </div>
            <div v-if="getRoleName(selecteduser.role).type === 'sales'"
              class="mt-[16px] rounded-[4px] border-[1.5px] border-solid border-[#DBDCE0] w-full mt-[16px]">
              <div class="w-full bg-[#fbfbfb] py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-bold text-[12px] leading-[18px] text-[#353535]">
                  Assigned Rights
                </h2>
              </div>
              <div v-if="selecteduser.role.isDistributorManager"
                class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-medium text-[14px] leading-[17px] text-[#353535]">
                  Manage Distributors
                </h2>
              </div>
              <div v-if="selecteduser.role.isGroupManager"
                class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-medium text-[14px] leading-[17px] text-[#353535]">
                  Manage Groups
                </h2>
              </div>
              <div v-if="selecteduser.role.isStateManager"
                class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-medium text-[14px] leading-[17px] text-[#353535]">
                  Manage State
                </h2>
              </div>
              <div v-if="selecteduser.role.canManageDistributorManagers"
                class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-medium text-[14px] leading-[17px] text-[#353535]">
                  Manage Distributor Managers
                </h2>
              </div>
              <div v-if="selecteduser.role.canManageGroupManagers"
                class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-medium text-[14px] leading-[17px] text-[#353535]">
                  Manage Group Manager
                </h2>
              </div>
              <div v-if="selecteduser.role.canManageStateManagers"
                class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-medium text-[14px] leading-[17px] text-[#353535]">
                  Manage State Manager
                </h2>
              </div>
            </div>
          </div>
        </div>

        <!-- distributors -->
        <div v-if="activeTab === 'distributor'">
          <div class="px-[24px] bg-white py-[32px] mt-[16px] rounded-[4px] min-h-auto">
            <div class="flex justify-between items-center">
              <h2 class="font-semibold text-[20px] leading-[20px] text-[#353535]">
                Assigned Distributors
              </h2>
              <button
                class="text-white bg-[#2463EB] text-[14px] font-normal py-[12px] px-[24px] rounded-[8px] border-[#2463EB] border-solid border-[1.6px] outline-none font-semibold"
                @click="togleAddModal('distributors')">
                Assign Distributor
              </button>
            </div>
            <div class="mt-[16px] rounded-[4px] border-[1.5px] border-solid border-[#DBDCE0]">
              <div class="w-full bg-[#fbfbfb] py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-bold text-[12px] leading-[18px] text-[#353535]">
                  Assigned Distributors
                </h2>
              </div>
              <div v-for="(i, index) in userMappings.distributorMapping" :key="index"
                class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0] flex items-center gap-[48px]">
                <h2 class="font-medium text-[14px] leading-[17px] max-w-[300px] w-full text-[#353535]">
                  {{ i.distributorName }}
                </h2>
                <span @click="togleAddModal('distributors')"
                  class="text-[#DC2828] font-normal text-[14px] leading-[20px] cursor-pointer">Remove</span>
              </div>
              <div v-if="!userMappings.distributorMapping.length"
                class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-medium text-[14px] leading-[17px] max-w- text-[#353535]">
                  No User is currently assigned to this Sales User
                </h2>
              </div>
            </div>
          </div>
        </div>

        <!-- group -->
        <div v-if="activeTab === 'groups'">
          <div class="px-[24px] bg-white py-[32px] mt-[16px] rounded-[4px] min-h-auto">
            <div class="flex justify-between items-center">
              <h2 class="font-semibold text-[20px] leading-[20px] text-[#353535]">
                Assigned Groups
              </h2>
              <button
                class="text-white bg-[#2463EB] text-[14px] font-normal py-[12px] px-[24px] rounded-[8px] border-[#2463EB] border-solid border-[1.6px] outline-none font-semibold"
                @click="togleAddModal('group')">
                Assign Group
              </button>
            </div>
            <div class="mt-[16px] rounded-[4px] border-[1.5px] border-solid border-[#DBDCE0]">
              <div class="w-full bg-[#fbfbfb] py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-bold text-[12px] leading-[18px] text-[#353535]">
                  Assigned Groups
                </h2>
              </div>
              <div class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0] flex items-center gap-[48px]">
                <h2 class="font-medium text-[14px] leading-[17px] text-[#353535]">
                  HFMP-LAG 2
                </h2>
                <span class="text-[#DC2828] font-normal text-[14px] leading-[20px] cursor-pointer"
                  @click="toggleGroupRemoval">Remove</span>
              </div>
            </div>
          </div>
        </div>

        <!-- state -->
        <div v-if="activeTab === 'state'">
          <div class="px-[24px] bg-white py-[32px] mt-[16px] rounded-[4px] min-h-auto">
            <div class="flex justify-between items-center">
              <h2 class="font-semibold text-[20px] leading-[20px] text-[#353535]">
                Assigned States
              </h2>
              <button
                class="text-white bg-[#2463EB] text-[14px] font-normal py-[12px] px-[24px] rounded-[8px] border-[#2463EB] border-solid border-[1.6px] outline-none font-semibold"
                @click="togleAddModal('state')">
                Assign state
              </button>
            </div>
            <div class="mt-[16px] rounded-[4px] border-[1.5px] border-solid border-[#DBDCE0]">
              <div class="w-full bg-[#fbfbfb] py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-bold text-[12px] leading-[18px] text-[#353535]">
                  Assigned states
                </h2>
              </div>
              <div class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0] flex items-center gap-[48px]">
                <h2 class="font-medium text-[14px] leading-[17px] text-[#353535]">
                  Abia
                </h2>
                <span @click="toggleStateRemoval"
                  class="text-[#DC2828] font-normal text-[14px] leading-[20px] cursor-pointer">Remove</span>
              </div>
            </div>
          </div>
        </div>

        <!-- team -->
        <div v-if="activeTab === 'team'">
          <div class="px-[24px] bg-white py-[32px] mt-[16px] rounded-[4px] min-h-auto">
            <div class="flex justify-between items-center">
              <h2 class="font-semibold text-[20px] leading-[20px] text-[#353535]">
                Assigned Teams
              </h2>
              <button
                class="text-white bg-[#2463EB] text-[14px] font-normal py-[12px] px-[24px] rounded-[8px] border-[#2463EB] border-solid border-[1.6px] outline-none font-semibold"
                @click="togleAddModal('teams')">
                Assign team
              </button>
            </div>
            <div class="mt-[16px] rounded-[4px] border-[1.5px] border-solid border-[#DBDCE0]">
              <div class="w-full bg-[#fbfbfb] py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-bold text-[12px] leading-[18px] text-[#353535]">
                  Assigned Teams
                </h2>
              </div>
            </div>
            <div v-for="(i, index) in userMappings.salesTeamMapping" :key="index"
              class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0] flex items-center gap-[48px]">
              <h2 class="font-medium text-[14px] leading-[17px] max-w-[300px] w-full text-[#353535]">
                {{ i.staffName }}
              </h2>
              <span @click="togleAddModal('teams')"
                class="text-[#DC2828] font-normal text-[14px] leading-[20px] cursor-pointer">Remove</span>
            </div>
            <div v-if="!userMappings.salesTeamMapping.length"
              class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
              <h2 class="font-medium text-[14px] leading-[17px] max-w-max text-[#353535]">
                No Team is currently assigned to this Sales User
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AssignMembers :switcher="switcher" :selecteduser="selecteduser" :openAssignModal="openAssignModal" :maps="[]"
      :openTeamModal="openTeamModal" :editingUser="viewEditUser" :mappingType="mappingType" />
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import SystemPermissions from "@/permissions";
import Select2 from "@/components/Select2";
import Pagination from "../Pagination.vue";
import AssignMembers from "./AssignMembers.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  props: [
    "viewEditUser",
    "viewRemove",
    "viewResend",
    "users",
    "pageNumber",
    "pageSize",
    "count",
    "pageCount",
    "changePage",
    "changeLimit",
    "modalUser",
    "loading",
  ],
  components: {
    Select2,
    Pagination,
    AssignMembers,
  },
  data() {
    return {
      switcher: "",
      filter: {
        status: "0",
        role: "0",
        qry: "",
      },
      mappingType: "",
      isBusy: false,
      isBusyModal: false,
      showDropdown: null,
      userMappings: {
        distributorMapping: [],
      },
      isModalVisible: false,
      selecteduser: {},
      activeTab: "profile",
      showRemoveModal: false,
      createUser: {
        username: null,
        password: null,
        phoneNumber: null,
        emailAddress: null,
        name: null,
        role: null,
        branch: null,
        staffId: null,
        salesAccessId: null,
      },

      editingUser: {
        emailAddress: null,
        phoneNumber: null,
        displayName: null,
        role: null,
        branchId: null,
      },

      // modalUser: {
      //   emailAddress: null,
      //   displayName: null,
      // },
      Email: "",
      Branches: [],

      v2: {
        role: false,
      },

      v3: {
        branch: false,
      },

      v5: {
        name: false,
      },
      v6: {
        email: false,
      },
      v7: {
        phone: false,
      },

      roles: [],
      DeleteId: "",
      v8: {
        selectedOption: false,
      },

      selectedOption: "",
    };
  },

  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },

    enableInviteOption: function () {
      return this.modalUser.emailAddress && this.modalUser.phoneNumber;
    },
  },

  methods: {
    async resetPassword(u) {
      let user = u;
      let email = user.emailAddress;
      try {
        this.isBusyModal = true;
        const res = await this.$http.put(`/Users/resetPassword`, {
          email: email,
        });
        const data = await res.json();
        this.isBusyModal = false;
        this.$toast.success("Password Reset Successfully.", {
          icon: true,
          rtl: false,
        });
      } catch (err) {
        this.isBusyModal = false;
      }
    },
    async viewUser(u) {
      try {
        let userType = u.userType || "";
        let url = "";
        if (userType === "Office") {
          url = `/Users/getById/${u.id}`;
        } else if (userType === "SalesForce") {
          url = `/SalesUsers/getById/${u.id}`;
        } else {
          url = `/Users/getById/${u.id}`;
        }
        const response = await this.$http.get(url);
        this.selecteduser = await response.json();
        this.isModalVisible = true;
        this.activeTab = "profile";
        await this.getUserMappings();
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    getRoleName(role) {
      if (!role) {
        return { role: "", type: null };
      }

      if (typeof role == "string") {
        return { role: role, type: "business" };
      } else {
        return { role: role.roleName, type: "sales" };
      }
    },
    reset() {
      this.page = 1;
      this.filter = {
        status: "0",
        role: "0",
        qry: "",
      };
    },
    switchTab(tab) {
      this.activeTab = tab;
    },
    editingUsers(user) {
      this.user = this.editingUser;
      this.$nextTick(() => {
        $("#mod-edit").modal("show");
      });
      this.closeModal();
    },
    OpenDisable(u) {
      this.viewRemove(u);
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
    },
    openModal() {
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    async openAssignModal() {
      await this.getUserMappings();
      this.activeTab = "distributor";
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    async openTeamModal() {
      await this.getUserMappings();
      this.activeTab = "team";
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    toggleRemoveModal() {
      $("#mod-remove").modal("show");
      this.closeModal();
    },
    togleAddModal(type) {
      if (type == "distributors") {
        this.mappingType = "Distributor";
        $("#mod-assign-distributor").modal("show");
      }
      if (type == "teams") {
        this.mappingType = "Team";
        $("#mod-assign-team").modal("show");
      }
      if (type == "group") {
        this.mappingType = "Group";
        $("#mod-assign-group").modal("show");
      }
      if (type == "state") {
        this.mappingType = "State";
        $("#mod-assign-state").modal("show");
      }

      this.closeModal();
    },
    toggleGroupRemoval() {
      $("#mod-group-remove").modal("show");
      this.closeModal();
    },

    toggleStateRemoval() {
      $("#mod-state-remove").modal("show");
      this.closeModal();
    },

    toggleTeamRemoval() {
      $("#mod-team-remove").modal("show");
      this.closeModal();
    },
    toggleDropdown(userId) {
      this.showDropdown = this.showDropdown === userId ? null : userId;
    },
    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },
    handleEditFinish() {
      $("#mod-edit-user").modal("hide");
      this.getUsers();
    },
    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    async deleteUser() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(
          `/Users/deleteUser/${this.DeleteId}`
        );
        if (res.ok) {
          this.$toast.success("User deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getUsers();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },

    viewAdd() {
      $("#mod-add").modal("show");
    },

    viewAddManual() {
      $("#mod-add-manual").modal("show");
    },

    viewEdit(u) {
      this.editingUser = u;
      $("#mod-edit").modal("show");
    },

    viewFilter() {
      this.page = 1;
      $("#mod-filter").modal("show");
    },

    handleCreateUserComplete() {
      $("#mod-add-manual").modal("hide");
      this.getUsers();
    },
    async getUserMappings() {
      try {
        var a = true;
        const res = await this.$http.get(
          "/SalesUsers/getMappings/" + this.selecteduser.id
        );
        const data = await res.json();
        this.userMappings = JSON.parse(JSON.stringify(data));
      } catch (err) { }
    },

    formatDate(date) {
      return moment(date).format("lll");
    },
  },
};
</script>
